<template>
    <header>
        <main-navbar></main-navbar>
    </header>

    <main class="column main-content">
        <router-view></router-view>
    </main>
</template>

<script>
import MainNavbar from './MainNavbar.vue'

export default {
    name: 'DashboardView',
    components: {
        MainNavbar,
    },
}
</script>
